import { Box, Button } from '@timelyapp/react';
import classNames from 'classnames';
import React from 'react';
import styles from './DownloadIntegrationButton.module.scss';

interface DownloadIntegrationButtonProps
  extends Omit<React.HTMLProps<HTMLButtonElement>, 'action' | 'ref'> {
  action?: React.ReactNode;
  description?: string;
  downloadLink?: string;
  openInNewWindow?: boolean;
  heading: string;
  icon:
    | React.ComponentType<{ className?: string; width?: string | number; height?: string | number }>
    | string;
  onDownload?: () => void;
}

const DownloadIntegrationButton = React.forwardRef<
  HTMLButtonElement,
  DownloadIntegrationButtonProps
>(
  (
    {
      action = 'Download',
      openInNewWindow = false,
      className,
      description,
      downloadLink,
      heading,
      icon: Icon,
      onDownload,
      ...props
    },
    ref
  ) => {
    return (
      <Button
        ref={ref}
        size="large"
        priority="xhigh"
        className={classNames(styles.button, className)}
        {...(props as React.HTMLAttributes<HTMLButtonElement>)}
      >
        {typeof Icon === 'string' ? (
          <img className={styles.icon} src={Icon} width={32} height={32} style={{ margin: 0 }} />
        ) : (
          <Icon className={styles.icon} width={32} height={32} />
        )}

        <Box.Column className={styles.content} gap="small" alignItems="flex-start">
          <span className={styles.heading}>{heading}</span>
          {!!description && (
            <>
              <span className={styles.description}>{description}</span>
            </>
          )}
        </Box.Column>
        <span className={styles.action}>{action}</span>
        {!!downloadLink && !props.disabled && (
          <a
            className={styles.downloadLink}
            href={downloadLink}
            onClick={onDownload}
            download={!openInNewWindow}
            target={openInNewWindow ? '_blank' : '_self'}
            rel="noreferrer noopener"
          >
            {action} {heading}
          </a>
        )}
      </Button>
    );
  }
);

DownloadIntegrationButton.displayName = 'DownloadIntegrationButton';
export default DownloadIntegrationButton;
